import { ROUTES } from '@/shared/constants/routes';
import { useAppDispatch, useAppSelector } from '@/shared/hooks/useStore';
import { useTrans } from '@/shared/hooks/useTranslation';
import { initialsOf } from '@/viewmodel/features/user/mappers/profile';
import { selectUserData, signedOut } from '@/viewmodel/features/user/state/userSlice';
import type { AccountMenuViewState } from '@/viewmodel/features/user/types';
import { useLogto } from '@logto/react';
import { useNavigate } from 'react-router-dom';

export function useAccountMenuViewModel(): AccountMenuViewState {
  const { t } = useTrans();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { signOut } = useLogto();
  const user = useAppSelector(selectUserData).data;

  return {
    initials: user ? initialsOf(user.name || t('common.user')) : null,
    openSettings: () => navigate(ROUTES.SETTINGS),
    signOut: () => {
      dispatch(signedOut());
      signOut(`${import.meta.env.VITE_APP_URL}/`);
    },
  };
}
